import * as React from 'react';

import { IconTimer } from '../../../src/shared/components/icons/large/IconTimer/IconTimer';
import { formatTime } from '../utils/formatTime';

interface StaticTimerDisplayProps {
  timerSeconds: number;
}

export const StaticTimerDisplay: React.FC<StaticTimerDisplayProps> = ({
  timerSeconds,
}) => {
  const formattedTime = formatTime(timerSeconds);

  return (
    <div className="quiz-timer">
      <IconTimer state="not-started" status="paused" />
      <span className="quiz-timer__time paused" aria-hidden="true">
        {formattedTime}
      </span>
    </div>
  );
};
